import React, { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.scss";

type Props = { children?: ReactNode };

const Footer: FC<Props> = ({ children, ...props }) => {
  const headerLinks = () => (
    <>
      <div className={styles.item}>
        <Link className="navLink" to="/about">
          硬件产品
        </Link>
      </div>
      <div className={styles.item}>
        <Link className="navLink" to="/">
          软件产品
        </Link>
      </div>
      <div className={styles.item}>
        <Link className="navLink" to="/">
          社区
        </Link>
      </div>
      <div className={styles.item}>
        <Link className="navLink" to="/">
          开放平台
        </Link>
      </div>
      <div className={styles.item}>
        <Link className="navLink" to="/">
          企业服务
        </Link>
      </div>
      <div className={styles.item}>
        <Link className="navLink" to="/">
          服务支持
        </Link>
      </div>
    </>
  );

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content1}>
          <div className={styles.products}>
            <div className={styles.productsList}>
              <div className={styles.productItem}>
                <a href="/cn/products/pico4-pro">PICO 4 Pro</a>
              </div>
              <div className={styles.productItem}>
                <a href="/cn/products/pico4">PICO 4</a>
              </div>
              <div className={styles.productItem}>
                <a href="/cn/products/pico4e">PICO 4 Enterprise</a>
              </div>
              <div className={styles.productItem}>
                <a href="/cn/products/neo3">PICO Neo3</a>
              </div>
              <div className={styles.productItem}>
                <a href="/cn/products/neo3-pro-eye">PICO Neo3 Pro/Pro Eye</a>
              </div>
              <div className={styles.productItem}>
                <a href="/cn/products/g3">PICO G3</a>
              </div>
              <div className={styles.productItem}>
                <a href="/cn/products/g2-4k">PICO G2 4K/4K Plus</a>
              </div>
            </div>
          </div>
          <div className={styles.links}>
            <div className={styles.linkList}>
              <div className={styles.content1211}>PICO 服务</div>
              <div className={styles.content1212}>
                <a href="https://www.picoxr.com/cn/dealers.html">线下零售店</a>
              </div>
              <div className={styles.content1212}>
                <a href="https://developer-cn.pico-interactive.com/">开发者</a>
              </div>
              <div className={styles.content1212}>
                <a href="https://github.com/picoxr/support">GitHub</a>
              </div>
            </div>
            <div className={styles.linkList}>
              <div className={styles.content1211}>用户与社群</div>
              <div className={styles.content1212}>
                <a href="https://space.bilibili.com/396895652">B站</a>
              </div>
              <div className={styles.content1212}>
                <a href="https://weibo.com/picovr">官方微博</a>
              </div>
              <div className={styles.content1212}>
                <a href="https://bbs-tmp.picovr.com/">PICO 论坛</a>
              </div>
            </div>
            <div className={styles.linkList}>
              <div className={styles.content1211}>更多</div>
              <div className={styles.content1212}>
                <a href="/cn/legal/terms-of-service">用户协议</a>
              </div>
              <div className={styles.content1212}>
                <a href="/cn/legal">隐私中心</a>
              </div>
              <div className={styles.content1212}>
                <a href="/cn/safety-center/security-privacy">安全中心</a>
              </div>
              <div className={styles.content1212}>
                <a href="https://jobs.bytedance.com/experienced/position?keywords=PICO">
                  社会招聘
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.content2}>
          <div>
            <div className={styles.content21}>客户服务热线</div>
            <div className={styles.content22}>400-1006-822</div>
            <div className={styles.content23}>周一至周日9:00-21:00</div>
          </div>
        </div>
        <div className={styles.content3}>
          <div className={styles.content31}>
            <div>
              All rights reserved Copyright 2015-2021 Pico Technology Co. Ltd.
            </div>
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://beian.miit.gov.cn/#/Integrated/index"
              >
                琼ICP备 2022001280号
              </a>
            </div>
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://lf3-statics-cn.picovr.com/obj/pico-fe-cn/pico/pico_website/public/business_license.pdf"
              >
                告琼B2-20220003
              </a>
            </div>
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://lf3-statics-cn.picovr.com/obj/pico-fe-cn/pico/pico_website/image/web_license.8c733120.jpeg"
              >
                琼网文（2022）2397-127号
              </a>
            </div>
            <div className={styles.govs}>
              <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010602001604"
                rel="noreferrer"
              >
                <img src="https://lf3-statics-cn.picovr.com/obj/pico-fe-cn/pico/pico_website/image/ico_backup.0c577066.png" />
                <p>琼公网安备 46010602001604号</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
